import { useMapGetter } from 'dashboard/composables/store';
import { computed } from 'vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export function useWgptAuditTrail() {
  const currentAccountId = useMapGetter('getCurrentAccountId');
  const isFeatureEnabledonAccount = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );
  const isFeatureEnabled = computed(() => {
    return isFeatureEnabledonAccount.value(
      currentAccountId.value,
      FEATURE_FLAGS.WGPT_AUDIT_TRAIL
    );
  });

  return {
    isFeatureEnabled,
  };
}
